export const CreditCardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#262627"
      fillRule="evenodd"
      d="M2.267 2.667h11.466a1.6 1.6 0 0 1 1.6 1.6v7.466a1.6 1.6 0 0 1-1.6 1.6H2.267a1.6 1.6 0 0 1-1.6-1.6V4.267a1.6 1.6 0 0 1 1.6-1.6Zm12.4 2.666H1.333v2h13.334v-2Zm-4 4a.667.667 0 0 1 .666-.666h2a.667.667 0 1 1 0 1.333h-2a.667.667 0 0 1-.666-.667Z"
      clipRule="evenodd"
    />
  </svg>
);
